import * as fsOps from '../fs-operations'
import type { FSContext, IFile } from '../types'

export function useDeleteCore(context: FSContext) {
  const deleteFiles = async (files: IFile[], domain: number) => {
    const failedList: IFile[] = []

    const results = await Promise.allSettled(
      files.map((file) =>
        fsOps.rm(context, {
          path: file.path,
          domain,
        }),
      ),
    )

    results.forEach((result, index) => {
      if (result.status === 'rejected') {
        failedList.push(files[index])
      }
    })

    // Trigger refresh if any files were successfully deleted
    if (failedList.length < files.length) {
      fsOps.refresh(context, { domain })
    }

    return failedList
  }

  return {
    deleteFiles,
  }
}
